function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paste-from-office/normalizers/mswordnormalizer
 */
import { parseHtml } from '../filters/parse';
import { transformListItemLikeElementsIntoLists } from '../filters/list';
import { replaceImagesSourceWithBase64 } from '../filters/image';
var msWordMatch1 = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i;
var msWordMatch2 = /xmlns:o="urn:schemas-microsoft-com/i;
/**
 * Normalizer for the content pasted from Microsoft Word.
 *
 * @implements module:paste-from-office/normalizer~Normalizer
 */

var MSWordNormalizer =
/*#__PURE__*/
function () {
  /**
   * Creates a new `MSWordNormalizer` instance.
   *
   * @param {module:engine/view/document~Document} document View document.
   */
  function MSWordNormalizer(document) {
    _classCallCheck(this, MSWordNormalizer);

    /**
     * @readonly
     * @type {module:engine/view/document~Document}
     */
    this.document = document;
  }
  /**
   * @inheritDoc
   */


  _createClass(MSWordNormalizer, [{
    key: "isActive",
    value: function isActive(htmlString) {
      return msWordMatch1.test(htmlString) || msWordMatch2.test(htmlString);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute(data) {
      var _parseHtml = parseHtml(data.dataTransfer.getData('text/html'), this.document.stylesProcessor),
          body = _parseHtml.body,
          stylesString = _parseHtml.stylesString;

      transformListItemLikeElementsIntoLists(body, stylesString);
      replaceImagesSourceWithBase64(body, data.dataTransfer.getData('text/rtf'));
      data.content = body;
    }
  }]);

  return MSWordNormalizer;
}();

export { MSWordNormalizer as default };